import React, { Component } from 'react';
import {ResultService} from "../../services/resultService";

class Oevelse extends Component {

    constructor(props) {
        super(props);
        this.state = {
            poengValue: '',
            dommerKommentarValue: '',
            poengSum: '',
            feilPoengInput: false
        };

        this.postPoeng = this.postPoeng.bind(this);
        this.postDommerKommentar = this.postDommerKommentar.bind(this);
        this.handlePoengChange = this.handlePoengChange.bind(this);
        this.handleDommerKommentarChange = this.handleDommerKommentarChange.bind(this);
        this.setDefaultState = this.setDefaultState.bind(this);

    }

    componentDidMount() {
        if (this.props.oevelse) {
            this.setDefaultState(this.props.oevelse);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.oevelse.oppnaaddPoeng !== nextProps.oevelse.oppnaaddPoeng
            || this.props.oevelse.dommerKommentar !==  nextProps.oevelse.dommerKommentar) {
            this.setDefaultState(nextProps.oevelse);
            this.setState({feilPoengInput: false});
        }
    }

    render() {
        const {oevelse, fraOevelse, tilOevelse, ikkeMoedt, roedtKort, delPartiCheckedIn, underKlassePartier} = this.props;

        const nr = oevelse.nr;
        const navn = oevelse.navn;
        const koeffisient = oevelse.koeffisient;
        let disablePoengField = false;
        let disableDommerKommentarField = false;


        if (delPartiCheckedIn !== null || ikkeMoedt) {
            disablePoengField = true;
            disableDommerKommentarField = true;
        } else {
            if (koeffisient === null || roedtKort) {
                disablePoengField = true;
            }
            if (fraOevelse !== null && tilOevelse !== null &&  (nr < fraOevelse || nr > tilOevelse)) {
                disablePoengField = true;
                disableDommerKommentarField = true;
                for (var i = 0; i < underKlassePartier.length; i++) {
                    if (underKlassePartier[i].checkedOut !== null
                        && nr >= underKlassePartier[i].fraOevelse
                        && nr <= underKlassePartier[i].tilOevelse) {

                        if (koeffisient !== null && !roedtKort) {
                            disablePoengField = false;
                        }
                        disableDommerKommentarField = false;
                    }
                }

            }

        }



        const poeng = oevelse.oppnaaddPoeng;
        const poengSum = this.state.poengSum;

        let className = poengInput;
        if (this.state.feilPoengInput) {
            className = feilPoengInput;
        }
        return (
            <tr>
                <td align="left" valign="top"><span>{nr}<br/><strong>{navn}</strong></span></td>
                <td  align="center" valign="top"><strong>{koeffisient}</strong></td>
                <td  align="center" valign="top">
                    <input style={className} type="number" value={this.state.poengValue} onChange={this.handlePoengChange}
                           onBlur={(e) => this.postPoeng(e, poeng)} disabled={disablePoengField} className="center-text" />
                </td>
                <td  align="center" valign="top"><strong>{poengSum}</strong></td>

                <td>
                    <textarea rows="15" className="comment" value={this.state.dommerKommentarValue} disabled={disableDommerKommentarField}  onChange={this.handleDommerKommentarChange} onBlur={this.postDommerKommentar}  />
                </td>
            </tr>

        );
    }



    handlePoengChange(event) {
        if (event.target.value !== '' && (event.target.value < 0 || event.target.value > 10
                || (!ResultService.isVmMesterskap() && event.target.value >= 1 && event.target.value < 5))) {
            this.setState({
                feilPoengInput: true,
                poengSum : ''
            });

        }
        else {
            let poengSum = '';
            const koeffisient = this.props.oevelse.koeffisient;

            if (koeffisient !== null && koeffisient !== '' && event.target.value !== '') {

                poengSum = event.target.value * koeffisient;
            }
            this.setState({
                feilPoengInput: false,
                poengSum : poengSum
            });

        }
        this.setState({poengValue: event.target.value});
    }


    setDefaultState(oevelse) {
        let kommentar = oevelse.dommerKommentar;
        if (kommentar === null) {
            kommentar = '';
        }
        this.setState({
            dommerKommentarValue: kommentar
        });

        let poeng = oevelse.oppnaaddPoeng;
        let poengSum = oevelse.poengSum;
        if (poeng === null) {
            poeng = '';
            poengSum = '';
        }
        this.setState({
            poengValue: poeng,
            poengSum: poengSum

        });
    }


    postPoeng(event, tidligerePoeng) {
        const nr = this.props.oevelse.nr;
        const klasse = this.props.oevelse.oevelseKlasse;
        //console.log(klasse);
        let poengTotalt = this.props.poengTotalt;
        var value = event.target.value;
        var errorTekst = "";
        if (value > 10) {
            errorTekst = "Det kan max gives 10 points per øvelse";
        }
        if (value < 0) {
            errorTekst = "Negative points ikke tilladt";
        }
        if (!ResultService.isVmMesterskap() && value >= 1 && value < 5) {
            errorTekst = "Points 1-4 er ikke tilladt";
        }

        var nyOevelsePoengSum = ResultService.getOevelsePoengSum(this.props.oevelse.koeffisient, value);
        var tidligereOevelsePoengSum = ResultService.getOevelsePoengSum(this.props.koeffisient, tidligerePoeng);
        if (tidligereOevelsePoengSum !== null) {
            poengTotalt = poengTotalt - tidligereOevelsePoengSum;
        }
        if (nyOevelsePoengSum !== null) {
            poengTotalt = poengTotalt + nyOevelsePoengSum;
        }
        if (poengTotalt > 200 && klasse.indexOf("LP1") > -1) {
            errorTekst = "Max poeng i klasse 1 er 200 point";
        }
        else if (poengTotalt > 280 && klasse.indexOf("LP2") > -1) {
            errorTekst = "Max poeng i klasse 2 er 280 point";
        }
        else if (poengTotalt > 320 && (klasse.indexOf("LP3") > -1 || klasse.indexOf("LPE") > -1 || klasse.indexOf("LPC") > -1)) {
            errorTekst = "Max poeng i \" + klasse + \" 320 point";
        }
        if (errorTekst !== '') {
            alert(errorTekst);
            if (tidligerePoeng === null) {
                tidligerePoeng = '';
            }
            /*this.setState({
                poengValue: tidligerePoeng
            });
            event.target.value = tidligerePoeng;
            */
            return;
        }
        this.props.poengOppdatert(nr, event.target.value);


    }

    postDommerKommentar() {
        const nr = this.props.oevelse.nr;
        this.props.kommentarOppdatert(nr, this.state.dommerKommentarValue);
    }

    handleDommerKommentarChange(event) {
        this.setState({dommerKommentarValue: event.target.value});
    }

}
export default Oevelse;

const feilPoengInput = {
    width : '50px',
    backgroundColor : 'red'
};
const poengInput = {
    width : '50px',
    backgroundColor: 'white'
};




// WEBPACK FOOTER //
// ./src/pages/kritikk/Oevelse.js